import { getStore } from '~/globalStore';
import { getTranslator } from '~/translations';
import {getFallbackLanguage, getLanguage} from "~/stateGetter";
import refreshToken from "./refreshToken";

import get from "lodash/get";

export default async function authenticatedRequest(call, dispatch = getStore().dispatch) {
        try {
            return refreshToken(call)
        } catch(error) {
            const state = getStore().getState();
            const trans = getTranslator(getLanguage(state), getFallbackLanguage(state));
            const message = get(error, "response.data.friendly_error") || trans('errorPage.title');
            const errorCode = get(error, "response.status");

            // Redirects to auth page
            if (+errorCode === 403) {
                dispatch({ type: 'authenticate_errored', error: message,  });
                return;
            }
            
            throw error;
        };

    //
    // if('noauth' in callResult && callResult.noauth) {
    //     await dispatch(authenticate());
    //     return call();
    // }

    // return callResult;
}
